import React from 'react';
import { useNavigate } from 'react-router-dom';

export function GraphicsLimitReached({ graphicsLimitInfo, selectedTeamId }) {
  const navigate = useNavigate();

  return (
    <div className="create-graphic-container">
      <div className="empty-state-graphic">
        <h2>Graphics Limit Reached</h2>
        <p>
          You've reached your limit of {graphicsLimitInfo.graphicsLimit} saved
          graphics for your accessible team on the{' '}
          {graphicsLimitInfo.subscriptionPlan} plan.
        </p>
        <p>Upgrade to save more graphics or delete some existing ones.</p>
        <div
          style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            marginTop: '24px',
          }}
        >
          <button
            className="btn btn-primary"
            onClick={() => navigate('/membership')}
          >
            ⭐ View Upgrade Options
          </button>
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/team/${selectedTeamId}`)}
          >
            Back to Team Portal
          </button>
        </div>
      </div>
    </div>
  );
}

export function LoadingState() {
  return (
    <div className="create-graphic-container">
      <div className="empty-state-graphic">
        <img src="/PMlogoleft.png" alt="Playmaker Media Kit Logo" />
        <h2>⏳ Loading...</h2>
        <p>Getting your teams ready...</p>
      </div>
    </div>
  );
}

export function NoTeamsState({ teamSport }) {
  const navigate = useNavigate();

  return (
    <div className="create-graphic-container">
      <div className="empty-state-graphic">
        <h2>{teamSport === 'Softball' ? '🥎' : '⚾'} No Teams Yet</h2>
        <p>You need to create a team before making graphics!</p>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/create-team')}
        >
          Create Your First Team
        </button>
      </div>
    </div>
  );
}
